const LoadingSpinner = ({
  size = 40,
  color = "#9e9e9e",
  borderWidth = 4,
  className,
}) => {
  return (
    <div
      className={`${className}`}
      style={{
        width: size,
        height: size,
        borderRadius: "75%",
        border: `${borderWidth}px solid ${color}`,
        borderTopColor: "transparent",
        borderRightColor: "transparent",
        animation: "spin 1s linear infinite",
      }}
    />
  );
};

export default LoadingSpinner;
